// TODO: review colors with design team and simplify the color palette
export const borderColor = '#e0e0e0';
export const darkGreen = '#338087';
export const dividerColor = 'rgba(0, 0, 0, 0.12)';
export const grayBlue = '#4E646F';
export const iconColor = '#666666';
export const lightBlack = 'rgba(0, 0, 0, 0.10)';
export const lightGreen = '#63D886';
export const outlinedBorder = '#00C45280';
export const primaryBlue = '#04072d';
export const primaryColor = '#3d9384';
export const primaryGreen = '#00A13B';
export const primaryGreenHover = '#008F30';
export const warningColor = '#EF6C00';
export const grey = '#BDBDBD';
export const primaryDark = '#008F30';
export const textDisabled = 'rgba(0, 0, 0, 0.38)';
export const white = '#FFFFFF';
export const primaryText = '#000000';
export const warning = '#EF6C00';
export const unknownStatus = 'rgba(0, 0, 0, 0.12)';
export const offlineStatus = '#f44336';
export const hoverGreen = '#008c32';
export const hoverSecondaryGreen = '#00A13B';
export const black = '#000000';

export const chartColors: string[] = [
  '#2A2179',
  '#316931',
  '#579D8E',
  '#8CC3E9',
  '#D5C673',
  '#B6636C',
  '#92448C',
  '#71294A',
  '#2A2179',
  '#316931',
];

// TODO: review colors with design team and simplify the color palette
export const typographyColorKeys = {
  darkGreen: darkGreen,
  grayBlue: grayBlue,
  lightGreen: lightGreen,
  primaryBlue: primaryBlue,
  primaryColor: primaryColor,
  primaryGreen: primaryGreen,
  warningColor: warningColor,
  grey: grey,
  primaryDark: primaryDark,
  white: white,
  primaryText: primaryText,
  black: black,
};

export const getTypographyColor = (color: keyof typeof typographyColorKeys) => {
  return typographyColorKeys[color];
};
